// src/sections/productEngraving.js
var productEngraving = () => {
  const resetFontClass = (element) => {
    element.classList.remove("font--gilroy");
    element.classList.remove("font--avenir");
    element.classList.remove("font--bentham");
    element.classList.remove("font--cutivemono");
    element.classList.remove("font--moonflower");
  };
  const getCurrentImage = (form) => {
    let frontside = true;
    if (form.classList.contains("engraving--backside"))
      frontside = false;
    let image = false;
    if (frontside) {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-frontside"
      );
    } else {
      image = document.querySelector(
        ".slide--hero-image.slide--engraving-backside"
      );
    }
    return image;
  };
  const handleFontInput = (form, inputFonts, inputTexts) => {
    inputFonts.forEach((input) => {
      input.addEventListener("change", (event) => {
        event.preventDefault();
        const textInputs = Array.isArray(inputTexts) ? inputTexts : [inputTexts];
        textInputs.forEach((inputText) => {
          if (inputText) {
            resetFontClass(inputText);
            inputText.classList.add(input.dataset.font);
          }
        });
        const image = getCurrentImage(form);
        if (image) {
          const imageTextelement = image.querySelector(".engrave-text p");
          if (imageTextelement) {
            resetFontClass(imageTextelement);
            imageTextelement.classList.add(input.dataset.font);
          }
        }
      });
    });
  };
  const updateImage = (image, text) => {
    const textElement = image.querySelector(".engrave-text p");
    if (textElement)
      textElement.innerHTML = text;
  };
  const handleTextInput = (form, inputs) => {
    const image = getCurrentImage(form);
    const textInputs = Array.isArray(inputs) ? inputs : [inputs];
    textInputs.forEach((input) => {
      if (input) {
        input.addEventListener("input", () => {
          if (image)
            updateImage(image, input.value);
        });
      }
    });
  };
  const addIcon = (input, icon) => {
    const maxLength = input.maxLength ? input.maxLength : 1;
    if (input.value.length >= maxLength) {
    } else {
      input.value += icon;
      const inputEvent = new Event("input", {
        bubbles: true,
        cancelable: true
      });
      input.dispatchEvent(inputEvent);
    }
  };
  const handleIconInput = (form, iconContainer, inputs) => {
    if (!iconContainer)
      return false;
    const buttons = iconContainer.querySelectorAll("button");
    const textInputs = Array.isArray(inputs) ? inputs : [inputs];
    let currentlyFocusedInput = null;
    textInputs.forEach((input) => {
      if (input && input.dataset.symbols === "true") {
        input.addEventListener("focus", () => {
          currentlyFocusedInput = input;
        });
        input.addEventListener("blur", () => {
          setTimeout(() => {
            if (currentlyFocusedInput === input) {
              currentlyFocusedInput = null;
            }
          }, 100);
        });
      }
    });
    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const type = button.dataset.icon;
        let icon = "";
        switch (type) {
          case "star-icon":
            icon = "\u2605";
            break;
          case "heart-icon":
            icon = "\u2665";
            break;
          default:
            icon = "";
        }
        const symbolEnabledInputs = textInputs.filter(
          (input) => input && input.dataset.symbols === "true"
        );
        if (symbolEnabledInputs.length === 0) {
          alert("Icons can only be added to fields that support symbols");
          return;
        }
        let targetInput = null;
        if (currentlyFocusedInput && symbolEnabledInputs.includes(currentlyFocusedInput)) {
          targetInput = currentlyFocusedInput;
        } else if (symbolEnabledInputs.length === 1) {
          targetInput = symbolEnabledInputs[0];
        } else {
          const emptySymbolInput = symbolEnabledInputs.find((input) => input.value.trim() === "");
          if (emptySymbolInput) {
            targetInput = emptySymbolInput;
          } else {
            targetInput = symbolEnabledInputs[0];
          }
        }
        if (targetInput) {
          addIcon(targetInput, icon);
          targetInput.focus();
        }
      });
    });
  };
  const initForm = (form) => {
    const inputFonts = form.querySelectorAll('input[type="radio"]');
    const multipleInputs = [
      form.querySelector("#engraving-text-1"),
      form.querySelector("#engraving-text-2"),
      form.querySelector("#engraving-text-3"),
      form.querySelector("#engraving-text-4"),
      form.querySelector("#engraving-text-5")
    ].filter((input) => input !== null);
    const singleInput = form.querySelector("#engraving-text") || form.querySelector("#engraving-text-backside");
    const inputTexts = multipleInputs.length > 0 ? multipleInputs : singleInput;
    const iconContainer = form.querySelector(".engraving-icon-selector") ? form.querySelector(".engraving-icon-selector") : "";
    if (inputTexts) {
      handleFontInput(form, inputFonts, inputTexts);
      handleTextInput(form, inputTexts);
      handleIconInput(form, iconContainer, inputTexts);
    }
  };
  const productEngraving2 = () => {
    const forms = document.querySelectorAll(".variant.engraving");
    if (forms.length > 0) {
      forms.forEach((form) => initForm(form));
    }
  };
  productEngraving2();
};
export {
  productEngraving
};
